var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"views"}},[_c('div',[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.page.name))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.page.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }